import axios from 'axios';
import { variables } from '../Variables';

export const sendCalendarCreateApiErrorEmail = async (language = "en-GB", eventDetail) => {

    const translations = {
        "en-GB": {
            subject: "Calendar Event Creation Failed - Client ID:",
            greeting: "Dear Team,",
            intro1: "An issue occurred while creating a calendar event using the WHISE /calendars/create API.",
            intro2: "The system was unable to successfully create the event, and manual attention may be required.",
            errorDetails: "Error Details",
            clientId: "Client ID:",
            failureReason: "Reason of Failure:",
            eventDetails: "Event Details:",
            footer1: "Please review the above details and take the necessary action to resolve the issue.",
            footer2: "If the problem persists, kindly investigate the API response and system logs for further insights.",
            regards: "Regards,",
            system: "Smart Calendar System"
        },
        "fr-BE": {
            subject: "Échec de la création d’un événement calendrier - ID Client :",
            greeting: "Bonjour équipe,",
            intro1: "Un problème est survenu lors de la création d’un événement de calendrier via l’API WHISE /calendars/create.",
            intro2: "Le système n’a pas pu créer l’événement avec succès et une intervention manuelle pourrait être nécessaire.",
            errorDetails: "Détails de l’erreur",
            clientId: "ID du client :",
            failureReason: "Raison de l’échec :",
            eventDetails: "Détails de l’événement :",
            footer1: "Veuillez examiner les détails ci-dessus et prendre les mesures nécessaires pour résoudre le problème.",
            footer2: "Si le problème persiste, veuillez analyser la réponse de l’API ainsi que les journaux du système pour plus d’informations.",
            regards: "Cordialement,",
            system: "Système de calendrier intelligent"
        },
        "nl-BE": {
            subject: "Aanmaken van agenda-evenement mislukt - Klant-ID:",
            greeting: "Beste team,",
            intro1: "Er is een probleem opgetreden bij het aanmaken van een agenda-evenement via de WHISE /calendars/create API.",
            intro2: "Het systeem kon het evenement niet succesvol aanmaken en handmatige tussenkomst kan nodig zijn.",
            errorDetails: "Foutdetails",
            clientId: "Klant-ID:",
            failureReason: "Reden van mislukking:",
            eventDetails: "Details van het evenement:",
            footer1: "Gelieve de bovenstaande details te controleren en de nodige acties te ondernemen om het probleem op te lossen.",
            footer2: "Als het probleem aanhoudt, gelieve de API-respons en systeemlogs te onderzoeken voor verdere inzichten.",
            regards: "Met vriendelijke groeten,",
            system: "Slim kalendersysteem"
        }
    };

    const t = translations[language] || translations["en-GB"];

    const jsonconfig = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };

    let html = "";

    html += "<table width='600' style='border:1px solid gray;border-radius:16px;margin:auto;font-family:Roboto;'>";

    html += "<tr><td style='text-align:center;padding:30px 0 40px'>";
    html += `<img src='${variables.AgentSiteURL + "assets/logo-placeholder.png"}' width='200' style='display:block;margin:auto'/>`;
    html += "</td></tr>";

    // Greeting
    html += `<tr><td style='padding:30px 30px 10px;'><strong>${t.greeting}</strong></td></tr>`;

    // Intro
    html += `<tr><td style='padding:10px 30px;color:#6B7280;font-size:13px;line-height:1.6;'>${t.intro1}<br/><br/>${t.intro2}</td></tr>`;

    // Card
    html += "<tr><td style='padding:20px;'>";
    html += "<table width='100%' style='border:1px solid #E5E7EB;border-radius:12px;'>";

    html += `<tr><td style='padding:16px 20px;font-size:11px;font-weight:bold;'>${t.errorDetails}</td></tr>`;
    html += "<tr><td style='padding:0 20px;'><hr/></td></tr>";

    html += `<tr><td style='padding:12px 20px;'><strong>${t.clientId}</strong> ${eventDetail.clientId}</td></tr>`;
    html += `<tr><td style='padding:12px 20px;'><strong>${t.failureReason}</strong><br/>${eventDetail.reason}</td></tr>`;
    html += `<tr><td style='padding:12px 20px;'><strong>${t.eventDetails}</strong><pre style='background:#F9FAFB;padding:10px;'>${JSON.stringify(eventDetail.eventDetail)}</pre></td ></tr >`;

    html += "</table></td></tr>";

    // Footer
    html += `<tr><td style='padding:10px 30px;color:#6B7280;font-size:13px;'>${t.footer1}<br/><br/>${t.footer2}</td></tr>`;

    // Regards
    html += `<tr><td style='padding:0 30px 30px;'>${t.regards}<br/>${t.system}</td></tr>`;

    html += "</table>";

    let objEmail = {
        emailTo: "abdulsaboor5059@gmail.com",
        body: html,
        subject: `${t.subject} ${eventDetail.clientId}`,
        emailType: "agent"
    };

    const url = variables.API_URL + `Email/SendEmail?`;

    axios.post(url, JSON.stringify(objEmail), jsonconfig)
        .catch(err => console.error("Email error:", err));
};

export const sendCancelledVisitEmailToContact = async (emailTempleteObj) => {

    let emailTempleteNofiRequest = emailTempleteObj.notificationRequest;
    let estate = emailTempleteObj.estate;
    let validEamailRequest = emailTempleteObj.validRequest;

    const jsonconfig = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };

    let html = "";

    // Outer table
    html += "<table width='600' cellspacing='0' cellpadding='0' border='0' style='border: 1px solid gray; background-color: white; border-radius: 16px; margin: 0px auto;'>";

    // Logo
    html += "<tr>";
    html += "   <td style='text-align: center; padding: 30px 0px 20px 0px;'>";

    //if (officeLogoUrl) {
    //    html += "   <img src='" + officeLogoUrl + "' width='200' style='margin: 0 auto; display: block;' />";
    //} else if (clientSettings != null && clientSettings.logoUrl != undefined) {
    //    html += "   <img src='" + clientSettings.logoUrl + "' width='200' style='margin: 0 auto; display: block;' />";
    //} else {
    //    html += "   <img src='" + variables.AgentSiteURL + "assets/logo-placeholder.png' width='200' style='margin: 0 auto; display: block;' />";
    //}

    html += "   </td>";
    html += "</tr>";

    // Heading
    html += "<tr>";
    html += "   <td style='text-align: center; padding: 0 30px 6px 30px;'>";
    html += `       <h5 style='font-size: 16px; font-weight: 700; color: #111827; font-family: Roboto; margin: 0px; line-height: 1.4;'>Dear <span>${"firstName"} ${"name"}</span>,</h5>`;
    html += "   </td>";
    html += "</tr>";

    // Sub heading
    html += "<tr>";
    html += "   <td style='text-align: center; padding: 4px 50px 24px 50px;'>";

    if (validEamailRequest == "onHold") {
        if (emailTempleteNofiRequest == "waitingListNotification") {
            // waiting list
            html += `       <p style='font-size: 13px; font-weight: 400; color: #6B7280; font-family: Roboto; margin: 0px; line-height: 1.5;'>The property you are interested in is currently under offer and visits are temporarily suspended.</p>`;
        } else if (emailTempleteNofiRequest == "pendingRequestNotification") {
            // pending request
            html += `       <p style='font-size: 13px; font-weight: 400; color: #6B7280; font-family: Roboto; margin: 0px; line-height: 1.5;'>Your visit request for the property {property_name} has been cancelled because the property is currently under offer.</p>`;
        } else {
            // confirm request
            html += `       <p style='font-size: 13px; font-weight: 400; color: #6B7280; font-family: Roboto; margin: 0px; line-height: 1.5;'>Your confirmed visit for the property {property_name} scheduled on {visit_date_time} has been cancelled.</p>`;
        }
    } else {
        if (emailTempleteNofiRequest == "waitingListNotification") {
            // waiting list
            html += `       <p style='font-size: 13px; font-weight: 400; color: #6B7280; font-family: Roboto; margin: 0px; line-height: 1.5;'>The property you were interested in is no longer available for visits.</p>`;
        } else if (emailTempleteNofiRequest == "pendingRequestNotification") {
            // pending request
            html += `       <p style='font-size: 13px; font-weight: 400; color: #6B7280; font-family: Roboto; margin: 0px; line-height: 1.5;'>Your visit request for the property {property_name} has been cancelled.</p>`;
        } else {
            // confirm request
            html += `       <p style='font-size: 13px; font-weight: 400; color: #6B7280; font-family: Roboto; margin: 0px; line-height: 1.5;'>Your confirmed visit scheduled for {visit_date} at {visit_time} has been cancelled.</p>`;
        }
    }

    html += "   </td>";
    html += "</tr>";

    // Inner card
    html += "<tr>";
    html += "   <td style='padding: 0 20px 30px 20px;'>";
    html += "       <table width='100%' cellspacing='0' cellpadding='0' border='0' style='border: 1px solid gray; background-color: white; border-radius: 16px; margin: 0px;'>";
    html += "        <tbody>";

    // Section label
    html += "           <tr>";
    html += "               <td style='padding: 16px 20px 6px 20px;'>";
    html += `                   <p style='font-family: Roboto; font-size: 11px; font-weight: 700; color: #374151; text-align: left; margin: 0; text-transform: uppercase; letter-spacing: 0.7px;'>RESUME OF YOUR VISIT REQUEST</p>`;
    html += "               </td>";
    html += "           </tr>";

    // Divider
    html += "           <tr>";
    html += "               <td style='padding: 8px 20px 0 20px;'>";
    html += "                   <hr style='border: none; border-top: 1px solid #E5E7EB; margin: 0;'>";
    html += "               </td>";
    html += "           </tr>";

    // Reason label
    html += "           <tr>";
    html += "               <td style='padding: 16px 20px 6px 20px;'>";
    html += `                   <h5 style='font-family: Roboto; font-size: 13px; font-weight: 700; color: #111827; text-align: left; margin: 0;'>Reason:</h5>`;
    html += "               </td>";
    html += "           </tr>";

    // Reason text
    html += "           <tr>";
    html += "               <td style='padding: 0 20px 10px 20px;'>";

    if (validEamailRequest == "onHold") {
        if (emailTempleteNofiRequest == "waitingListNotification") {
            // waiting list
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6; margin-bottom: 8px;'>The owner has accepted an offer for the property. While the sale or rental process is ongoing, visits are temporarily unavailable.</p>`;
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6;'>You remain registered on the waiting list. If the property becomes available again, you will automatically be notified and given the opportunity to book a visit.</p>`;
        } else if (emailTempleteNofiRequest == "pendingRequestNotification") {
            // pending request
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6; margin-bottom: 8px;'>An offer has been accepted by the owner and visits are temporarily suspended while the transaction is being processed.</p>`;
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6; margin-bottom: 8px;'>You have been automatically added to the waiting list. If the property becomes available again, you will be notified.</p>`;
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6;'>If you no longer wish to remain on the waiting list, you may remove yourself using the button below.</p>`;
        } else {
            // confirm request
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6; margin-bottom: 8px;'>The property is currently under offer and visits have been temporarily suspended.</p>`;
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6;'>If the property becomes available again, new visit slots may be opened and you will be able to submit a new visit request.</p>`;
        }
    } else {
        if (emailTempleteNofiRequest == "waitingListNotification") {
            // waiting list
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6; margin-bottom: 8px;'>The property has been sold, rented, or removed from the market.</p>`;
        } else if (emailTempleteNofiRequest == "pendingRequestNotification") {
            // pending request
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6; margin-bottom: 8px;'>The property is no longer available because it has been sold, rented, or removed from the market.</p>`;
        } else {
            // confirm request
            html += `<p style='font-family: Roboto; font-size: 13px; text-align: left; margin: 0; line-height: 1.6; margin-bottom: 8px;'>The property has been sold, rented, or removed from the market and is no longer available for visits.</p>`;
        }
    }
            
    html += "               </td>";
    html += "           </tr>";

    if (emailTempleteNofiRequest == "pendingRequestNotification") {
        // Remove from waiting list button

        if (validEamailRequest == "onHold") {
            html += "           <tr>";
            html += "               <td style='padding: 0 20px 20px 20px; text-align: left;'>";
            html += `                   <a href='${variables.AgentSiteURL + `validateremoveevent/47170/6521728`}' style='display: inline-block; background-color: #2563EB; color: #ffffff; font-family: Roboto; font-size: 13px; font-weight: 600; text-decoration: none; padding: 10px 20px; border-radius: 8px;'>Remove from waiting list</a>`;
            html += "               </td>";
            html += "           </tr>";
        }

        // Divider
        html += "           <tr>";
        html += "               <td style='padding: 0 20px;'>";
        html += "                   <hr style='border: none; border-top: 1px solid #E5E7EB; margin: 0;'>";
        html += "               </td>";
        html += "           </tr>";

        // Visit details label
        html += "           <tr>";
        html += "               <td style='padding: 16px 20px 10px 20px;'>";
        html += `                   <h5 style='font-family: Roboto; font-size: 13px; font-weight: 700; color: #111827; text-align: left; margin: 0;'>Visit Details</h5>`;
        html += "               </td>";
        html += "           </tr>";

        // Date
        html += "           <tr>";
        html += "               <td style='padding: 0 20px 4px 20px;'>";
        html += "                   <p style='font-family: Roboto; font-size: 13px; color: #374151; text-align: left; margin: 0;'>";
        html += `                       <strong style='color: #111827;'>Date:</strong> 10-03-2026`;
        html += "                   </p>";
        html += "               </td>";
        html += "           </tr>";

        // Time
        html += "           <tr>";
        html += "               <td style='padding: 4px 20px 16px 20px;'>";
        html += "                   <p style='font-family: Roboto; font-size: 13px; color: #374151; text-align: left; margin: 0;'>";
        html += `                       <strong style='color: #111827;'>Date:</strong> 10-03-2026`;
        html += "                   </p>";
        html += "               </td>";
        html += "           </tr>";
    }

    // Divider
    html += "           <tr>";
    html += "               <td style='padding: 0 20px;'>";
    html += "                   <hr style='border: none; border-top: 1px solid #E5E7EB; margin: 0;'>";
    html += "               </td>";
    html += "           </tr>";

    // Property recap label
    html += "           <tr>";
    html += "               <td style='padding: 16px 20px 10px 20px;'>";
    html += `                   <h5 style='font-family: Roboto; font-size: 13px; font-weight: 700; color: #111827; text-align: left; margin: 0;'>Property Recap:</h5>`;
    html += "               </td>";
    html += "           </tr>";

    // Property: image left + details right
    html += "           <tr>";
    html += "               <td style='padding: 0 20px 16px 20px;'>";
    html += "                   <table width='100%' cellspacing='0' cellpadding='0' border='0'>";
    html += "                       <tr>";

    // Left: image
    html += "                           <td width='160' valign='top' style='padding-right: 16px;'>";
    if (estate.pictures != undefined && estate.pictures.length > 0 && estate.pictures[0].urlLarge != undefined) {
        html += "                           <img src='" + estate.pictures[0].urlLarge + "' width='160' alt='house image' style='border-radius: 6px; display: block; height: 105px; object-fit: cover;' />";
    }
    html += "                           </td>";

    // Right: details
    html += "                           <td valign='top'>";
    if (estate.name != undefined) {
        html += "                           <p style='font-family: Roboto; font-size: 13px; font-weight: 700; color: #111827; text-align: left; margin: 0 0 8px 0;'>" + estate.name + "</p>";
    }
    html += "                           <p style='font-family: Roboto; font-size: 13px; color: #6B7280; text-align: left; margin: 0 0 8px 0; vertical-align: middle;'>";
    html += "                               <img src='" + variables.AgentSiteURL + "assets/location-pin.png' width='13' style='vertical-align: middle;' />";
    html += "                               &nbsp;" + (estate.address ?? "") + " " + (estate.number ?? "") + ", " + (estate.zip ?? "") + " " + (estate.city ?? "");
    html += "                           </p>";
    html += "                           <p style='font-family: Roboto; font-size: 13px; color: #6B7280; text-align: left; margin: 0; vertical-align: middle;'>";
    html += "                               <img src='" + variables.AgentSiteURL + "assets/bed-duo.png' width='16' style='vertical-align: middle;' />";
    html += `                               <span style='vertical-align: middle;'>&nbsp;${estate.bedRooms ?? ""}</span>`;
    html += "                               <span style='vertical-align: middle; color: #D1D5DB;'>&nbsp;|&nbsp;</span>";
    html += "                               <img src='" + variables.AgentSiteURL + "assets/shower-duo.png' width='16' style='vertical-align: middle;' />";
    html += `                               <span style='vertical-align: middle;'>&nbsp;${estate.bathRooms ?? ""}</span>`;
    html += "                               <span style='vertical-align: middle; color: #D1D5DB;'>&nbsp;|&nbsp;</span>";
    html += "                               <img src='" + variables.AgentSiteURL + "assets/lift-duo.png' width='16' style='vertical-align: middle;' />";
    html += `                               <span style='vertical-align: middle;'>&nbsp;${estate.area ?? ""}</span>`;
    html += "                           </p>";
    html += "                           </td>";

    html += "                       </tr>";
    html += "                   </table>";
    html += "               </td>";
    html += "           </tr>";

    // Divider
    html += "           <tr>";
    html += "               <td style='padding: 0 20px;'>";
    html += "                   <hr style='border: none; border-top: 1px solid #E5E7EB; margin: 0;'>";
    html += "               </td>";
    html += "           </tr>";

    // Contact label
    html += "           <tr>";
    html += "               <td style='padding: 16px 20px 8px 20px;'>";
    html += `                   <h5 style='font-family: Roboto; font-size: 13px; font-weight: 700; color: #111827; text-align: left; margin: 0;'>Contact Details</h5>`;
    html += "               </td>";
    html += "           </tr>";

    // Contact name
    html += "           <tr>";
    html += "               <td style='padding: 0 20px 4px 20px;'>";
    html += `                   <p style='font-family: Roboto; font-size: 13px; color: #111827; text-align: left; margin: 0;'> "contact.firstName" "contact.name"</p>`;
    html += "               </td>";
    html += "           </tr>";

    // Contact email
    html += "           <tr>";
    html += "               <td style='padding: 2px 20px;'>";
    html += `                   <p style='font-family: Roboto; font-size: 13px; color: #2563EB; text-align: left; margin: 0;'> "contact.email"</p>`;
    html += "               </td>";
    html += "           </tr>";

    // Contact phone
    html += "           <tr>";
    html += "               <td style='padding: 2px 20px 20px 20px;'>";
    html += `                   <p style='font-family: Roboto; font-size: 13px; color: #374151; text-align: left; margin: 0;'>"contact.mobile"</p>`;
    html += "               </td>";
    html += "           </tr>";

    html += "        </tbody>";
    html += "       </table>";
    html += "   </td>";
    html += "</tr>";

    html += "</table>";


    let subject = "";

    if (validEamailRequest == "onHold") {
        if (emailTempleteNofiRequest == "waitingListNotification") {
            subject = "Visits for property {property_id} are temporarily suspended";
        } else if (emailTempleteNofiRequest == "pendingRequestNotification") {
            subject = "Update regarding your visit request for property {property_id}";
        } else {
            subject = "Your confirmed visit for property {property_id} has been cancelled";
        }
    } else {
        if (emailTempleteNofiRequest == "waitingListNotification") {
            subject = "Property {property_id} is no longer available";
        } else if (emailTempleteNofiRequest == "pendingRequestNotification") {
            subject = `Your visit request for property {property_id} has been cancelled`;
        } else {
            subject = `Your confirmed visit for property {property_id} has been cancelled`;
        }
    }

    let objEmail = {
        emailTo: "abdulsaboor5059@gmail.com",
        body: html,
        subject: subject,
        emailType: "contact"
    };

    const url = variables.API_URL + `Email/SendEmail?`;
    axios.post(url, JSON.stringify(objEmail), jsonconfig)
        .then(response => {
            let resp = response.data;
            console.log(resp);
        })
        .catch(error => {
            console.error('Error sending cancelled visit email:', error);
        });
};
